import React from 'react';
import SvgInline from '@latitude/svg-inline';
import { Typography } from '@latitude/typography';
import {
  StyledProofPointContainer,
  StyledProofPointContentContainer,
  StyledProofPointTextContainer,
  StyledProofPointIconContainer
} from './ProofPointRebrand.styled';
import Icon from '@/components/Icon/Icon';
import { BREAKPOINT, ICON_VARIANT, ICON_SIZE } from '@/utils/constants';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';

const ProofPointRebrand = ({ point, trackingId, numOfPoints = 3, title, ...rest }) => {
  const COMPONENT_ID = 'proof-point-rebrand';
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <StyledProofPointContainer
      numOfPoints={numOfPoints}
      className={componentIdentifier}
      href={point?.proofPointUrl}
      trackEventData={{
        action: 'internal-link',
        category: 'text-link',
        labek: point?.title,
        location: title
      }}
      {...rest}
    >
      <StyledProofPointContentContainer
        className={`${componentIdentifier}-content-container`}
      >
        {point?.icon && (
          <SvgInline
            className={`${componentIdentifier}-svg`}
            name={point.icon}
          />
        )}

        <StyledProofPointTextContainer
          className={`${componentIdentifier}-text-container`}
        >
          <Typography.LinkRegular color={REBRAND_COLOR.BLACK}>
            {point?.title}
          </Typography.LinkRegular>
        </StyledProofPointTextContainer>
        <StyledProofPointIconContainer>
          {point?.proofPointUrl && (
            <Icon
              variant={ICON_VARIANT.ARROW_CHEVRON_RIGHT}
              size={ICON_SIZE.SM}
              color={REBRAND_COLOR.MID_BLUE}
            />
          )}
        </StyledProofPointIconContainer>
      </StyledProofPointContentContainer>
    </StyledProofPointContainer>
  );
};

export default ProofPointRebrand;
